import React from 'react';

import { CLIENT_FORM } from '@common/schema/flow';
import { setIndexDBItem } from '@util/indexedDB';
import { toBase64data } from '@util/saveAndRetrieveImage';

import { FlowPage } from './FlowPage';

interface Props {
  city: string;
}

export const FlowConnector = (props: Props) => {
  const { city } = props;

  const defaultValues = {
    [CLIENT_FORM.CITY]: city,
    [CLIENT_FORM.PROBLEM_CATEGORY_ID]: undefined,
    [CLIENT_FORM.PROBLEM_SUB_CATEGORY_ID]: undefined,
    [CLIENT_FORM.CLIENT_COST]: undefined,
    [CLIENT_FORM.DATE_AND_TIME]: undefined,
    [CLIENT_FORM.DESCRIPTION]: '',
    [CLIENT_FORM.IMAGES]: undefined,
    [CLIENT_FORM.VIDEOS]: undefined,
    [CLIENT_FORM.FULL_NAME]: '',
    [CLIENT_FORM.EMAIL]: '',
    [CLIENT_FORM.PHONE_NUMBER]: '',
    [CLIENT_FORM.ADDRESS]: '',
  };

  const onSubmit = async (values: any) => {
    const { images, videos, ...otherProps } = values;

    let finalImages: any[] = [];
    let finalVideos: any[] = [];

    if (images && images.length > 0) {
      finalImages = await toBase64data(images);
    }
    if (videos && videos.length > 0) {
      finalVideos = await toBase64data(videos);
    }

    const flowData = {
      ...otherProps,
      title: 'abc',
      images: finalImages,
      videos: finalVideos,
    };
    setIndexDBItem('flowData', JSON.stringify(flowData));
  };
  return <FlowPage defaultValues={defaultValues} onSubmit={onSubmit} />;
};
